import React from 'react';
import Layout from '../components/layout/Layout';
import VO2MaxReportForm from '../components/reports/VO2MaxReportForm';

const VO2MaxReportPage = () => {
  return (
    <Layout>
      <VO2MaxReportForm />
    </Layout>
  );
};

export default VO2MaxReportPage;
